import { useStaticQuery, graphql } from "gatsby"
import { ButtonProps } from "../ts/interfaces"

type SiteConfig = {
  enableCoupons: boolean
  enableAffirmCanada: boolean
  enableAffirmUS: boolean
  toggleCheckoutCardText: string
  toggleCheckoutAffirmText: string
  payWithAffirmMessage: string
  payWithAffirmButtonText: string
  checkoutCreateAccountMessage: string
  checkoutNewsletterMessage: string
  cookieBanner?: string
  enableGifts: boolean
  enableAffirmMessaging: boolean
  logo: any
  logoOnDart: any
  proSignupImg?: any
  proContinueCheckoutTitle?: string
  proContinueCheckoutMsg?: string
  proContinueCheckoutButton?: ButtonProps
  proSignupAccountTitle?: string
  proSignupLoginTitle?: string
  proSignupOrgTitle?: string
  proSignupAccountMsg?: string
  proSignupOrgMsg?: string
  proAffiliateTitle?: string
  proAffiliateMsg?: string
  proAffiliateLinkedMsg?: string
}

export const useSiteConfig = () => {
  const { sensaiSiteConfig } = useStaticQuery(
    graphql`
      query {
        sensaiSiteConfig {
          enableCoupons
          toggleCheckoutCardText
          toggleCheckoutAffirmText
          payWithAffirmMessage
          payWithAffirmButtonText
          checkoutCreateAccountMessage
          checkoutNewsletterMessage
          cookieBanner
          enableGifts
          enableAffirmMessaging
          enableAffirmCanada
          enableAffirmUS
          logo {
            url
            imageFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: NONE
                  layout: FIXED
                  height: 135
                  width: 480
                )
              }
            }
          }
          logoOnDark {
            url
            imageFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: NONE
                  layout: FIXED
                  height: 135
                  width: 480
                )
              }
            }
          }
          proAffiliateTitle
          proAffiliateMsg
          proAffiliateLinkedMsg
          proSignupAccountTitle
          proSignupLoginTitle
          proSignupOrgTitle
          proSignupAccountMsg
          proSignupOrgMsg
          proContinueCheckoutTitle
          proContinueCheckoutMsg
          proContinueCheckoutButton {
            ...ButtonDetails
          }
          proSignupImg {
            url
            imageFile {
              childImageSharp {
                gatsbyImageData(
                  placeholder: NONE
                  layout: CONSTRAINED
                  width: 680
                  quality: 80
                )
              }
            }
          }
        }
      }
    `
  )

  return sensaiSiteConfig as SiteConfig
}
